exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr > td[data-v-e76d0600] {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin: 0; \n    white-space: nowrap;\n}\ntr > th[data-v-e76d0600] {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    margin: 0;\n    white-space: nowrap;\n}\n.no-padding[data-v-e76d0600] {\n    padding: 0 !important;\n    line-height: 1;\n    vertical-align: middle !important;\n}\n.shrink[data-v-e76d0600] {\n    width: 1%;\n}    \n", ""]);

// exports
